module.exports = __webpack_public_path__ + "Icono_CerrarSesion_Blanco_512px.png";